import { logger, hasSink } from './logger';

/**
 * Covers the window before the SDK is ready.
 *
 * The connection string only arrives with GET /settings, but the failures most worth catching
 * -- a bad bundle, a broken bootstrap fetch -- happen before that. These handlers push into the
 * logger's buffer so those errors are replayed once telemetry initialises.
 *
 * They are strictly temporary. The SDK hooks window.onerror and (with
 * enableUnhandledPromiseRejectionTracking) unhandledrejection itself, with better fidelity, so
 * leaving these in place would double-report. initTelemetry uninstalls them, and they also
 * no-op the moment the logger has a sink in case anything runs out of order.
 */
let onError = null;
let onRejection = null;

export function installBootstrapHandlers() {
  if (onError) return;

  onError = (event) => {
    if (hasSink()) return;
    logger.error(
      'Unhandled browser error before telemetry init',
      {
        Operation: 'Bootstrap',
        ErrorType: 'WindowError',
        Source: event?.filename,
        Line: event?.lineno,
        Column: event?.colno,
      },
      event?.error ?? event?.message
    );
  };

  onRejection = (event) => {
    if (hasSink()) return;
    logger.error(
      'Unhandled promise rejection before telemetry init',
      { Operation: 'Bootstrap', ErrorType: 'UnhandledRejection' },
      event?.reason
    );
  };

  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onRejection);
}

export function uninstallBootstrapHandlers() {
  if (onError) {
    window.removeEventListener('error', onError);
    onError = null;
  }
  if (onRejection) {
    window.removeEventListener('unhandledrejection', onRejection);
    onRejection = null;
  }
}
